// Mock data pour Kobinatech

export const mockData = {
  company: {
    name: "KOBINATECH",
    tagline: "Agence Digitale Kobinatech",
    heroTitle: "On ne fait pas du développement,",
    heroSubtitle: "on crée de l'innovation",
    description: "Kobinatech, l'agence de développement informatique qui combine expertise technique et vision business pour transformer vos idées en solutions digitales performantes."
  },

  stats: [
    {
      value: "+8",
      label: "Projets réalisés",
    },
    {
      value: "+5",
      label: "Clients satisfaits",
      sublabel: "en moins de 5 ans"
    },
    {
      value: "7",
      label: "Experts techniques en",
      sublabel: "développement et innovation"
    },
    {
      value: "95%",
      label: "Taux de satisfaction client",
      sublabel: "NPS sur l'année 2025"
    }
  ],

  services: [
    {
      title: "Web",
      description: "Développement d'applications web modernes et performantes",
      link: "/web"
    },
    {
      title: "Mobile",
      description: "Applications iOS et Android natives et cross-platform",
      link: "/mobile"
    },
    {
      title: "Cloud",
      description: "Solutions cloud scalables et architectures microservices",
      link: "/cloud"
    },
    {
      title: "IA & Data",
      description: "Intelligence artificielle et analyse de données avancée",
      link: "/ia"
    }
  ],

  clients: [
    { name: "THEA", logo: "https://cdn.prod.website-files.com/60c75078850651e0dfcb0945/6426cf9ebe43d9cc6799ae20_THEA.webp" },
    { name: "Lightspeed", logo: "https://cdn.prod.website-files.com/60c75078850651e0dfcb0945/68752194f8615c22d4b66c98_bp%20Lightsource.webp" },
    { name: "Merci Handy", logo: "https://cdn.prod.website-files.com/60c75078850651e0dfcb0945/68751eff1bc77777a4c24f37_merci%20handy.webp" },
    { name: "ORPI", logo: "https://cdn.prod.website-files.com/60c75078850651e0dfcb0945/6426cfa042b60f2c17cba5b9_ORPI.webp" },
    { name: "Archie", logo: "https://cdn.prod.website-files.com/60c75078850651e0dfcb0945/68751efe95a1f0d5052af997_ARCHIE.webp" },
    { name: "Kolsquare", logo: "https://cdn.prod.website-files.com/60c75078850651e0dfcb0945/6426cf9e0cccc11ca6edf2f4_KOLSQUARE.webp" },
    { name: "Clyde", logo: "https://cdn.prod.website-files.com/60c75078850651e0dfcb0945/6426cf9e0a675cbe7a4cd4ff_CLYDE.webp" },
    { name: "Araku", logo: "https://cdn.prod.website-files.com/60c75078850651e0dfcb0945/6426cf9e0a10a1524c0147f7_ARAKU.webp" }
  ],

  testimonials: [
    {
      name: "Sophie Martin",
      avatar: "https://cdn.prod.website-files.com/60c75078850651e0dfcb0945/646780fa922199c5618d9126_35.webp",
      text: "Une expérience exceptionnelle. L'équipe de Kobinatech a transformé notre vision en une application performante qui dépasse nos attentes."
    },
    {
      name: "Paul Mary Million",
      avatar: "https://media.licdn.com/dms/image/v2/D4E03AQHDizMfZjZ_JQ/profile-displayphoto-scale_400_400/B4EZpY9RnnKgAg-/0/1762429051040?e=1772064000&v=beta&t=lxW2PgupYsNTGoFB5loLMwzVU9CGcN83t_qvLqelDb8",
      text: "Je recommande Kobinatech aux entreprises qui recherchent un partenaire technique de confiance pour leurs projets digitaux."
    },
    
    {
      name: "Amos Jean Jaques",
      avatar: "https://scontent.fcdg3-1.fna.fbcdn.net/v/t39.30808-6/470588673_2034403247075598_7959467600992239865_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=6ee11a&_nc_ohc=lvjfFAk2gJ0Q7kNvwECi_8P&_nc_oc=AdkVLQUv9s4DACzFBQA8fnp32qHTvzx5f5TFjnftFaH_UtfPwHPb6aNXlVqGMxWhHhI&_nc_zt=23&_nc_ht=scontent.fcdg3-1.fna&_nc_gid=wwBBtJW_kALGKBUpNl7tEw&oh=00_AfufGdxqASJAW-h5FnNqOpGvVfzGH3-7JR76vdg_iQfXeA&oe=698EFBD0",
      text: "Je recommande l'équipe à 1000% ! Toujours disponibles, efficaces, rapides et de très bons conseils techniques."
    },
    {
      name: "Isabelle Rousseau",
      avatar: "https://cdn.prod.website-files.com/60c75078850651e0dfcb0945/6481a54ace30ba841d3e0d80_Capture%20d%E2%80%99e%CC%81cran%202023-06-08%20a%CC%80%2011.54.04.webp",
      text: "Plus qu'un accompagnement technique, c'est un véritable partenariat stratégique avec des conseils avisés et pertinents."
    }
  ],

  industries: [
    {
      title: "E-commerce",
      description: "Nous accompagnons startups et e-commerçants établis. De la plateforme jusqu'à l'optimisation, nous créons des solutions qui maximisent vos conversions.",
      image: "https://cdn.prod.website-files.com/60c75078850651e0dfcb0945/68c310d929b838ad0d69afea_7.webp"
    },
    {
      title: "SaaS & Startups",
      description: "Nous travaillons avec des startups innovantes et des éditeurs SaaS. Notre expertise : transformer vos idées en produits scalables et performants.",
      image: "https://cdn.prod.website-files.com/60c75078850651e0dfcb0945/68c310d8787193406a471a9b_8.webp"
    },
    {
      title: "Entreprises & PME",
      description: "Nous accompagnons entreprises et PME dans leur transformation digitale. Digitalisation des processus, applications métier sur-mesure et innovation.",
      image: "https://cdn.prod.website-files.com/60c75078850651e0dfcb0945/68c31e4b5fba17367c289b13_Design%20sans%20titre%20(7).webp"
    }
  ],

  process: [
    {
      title: "Découverte",
      duration: "2 jours",
      description: "Un premier échange pour comprendre votre projet, vos enjeux et vos objectifs. C'est l'occasion de vous présenter notre méthodologie et notre approche technique."
    },
    {
      title: "Analyse et conception",
      duration: "7 jours",
      description: "Nous analysons vos besoins techniques, votre marché et vos contraintes. À partir de là, nous élaborons une architecture technique claire et un plan d'action détaillé."
    },
    {
      title: "Développement",
      duration: "Variable",
      description: "Nos experts développent votre solution en mode agile. Livraisons régulières, tests continus et ajustements pour garantir un produit de qualité."
    },
    {
      title: "Accompagnement",
      duration: "En continu",
      description: "Support technique, maintenance évolutive et optimisations continues. Votre succès est notre priorité sur le long terme."
    }
  ],

  faq: [
    {
      question: "Qu'est-ce qui différencie Kobinatech des autres agences ?",
      answer: "Web, Mobile, Cloud, IA : nos experts maîtrisent l'ensemble de l'écosystème technique moderne. Nous ne nous contentons pas de coder, nous construisons des solutions qui font vraiment grandir votre business. Cette vision globale et notre expertise technique approfondie font de Kobinatech un véritable partenaire de croissance."
    },
    {
      question: "Quels résultats peut-on attendre en travaillant avec vous ?",
      answer: "Chaque projet est unique, mais notre objectif reste constant : livrer des solutions techniques performantes et évolutives. Selon vos besoins, cela peut être une application web/mobile robuste, une architecture cloud scalable, ou une solution IA innovante. Nous ne promettons pas l'impossible, nous construisons du concret et du durable."
    },
    {
      question: "Quelles technologies utilisez-vous ?",
      answer: "Nous travaillons avec les technologies modernes et éprouvées : React, Node.js, Python, React Native, AWS, Azure, TensorFlow et bien d'autres. Le choix technologique est toujours guidé par vos besoins spécifiques, pas par nos préférences."
    },
    {
      question: "Avec quels types d'entreprises travaillez-vous ?",
      answer: "Nous accompagnons startups, PME et grands groupes. De la jeune pousse ambitieuse à l'entreprise établie, ce qui compte c'est votre vision et votre volonté d'innover dans le digital."
    },
    {
      question: "Comment se passe la collaboration au quotidien ?",
      answer: "Un chef de projet dédié pilote votre développement. Communication par Slack, email ou visio, avec des outils de gestion partagés. Vous avez accès à l'avancement en temps réel. Fini les agences injoignables, nous travaillons en transparence totale."
    },
    {
      question: "Proposez-vous de la maintenance après la livraison ?",
      answer: "Absolument. Nous proposons des contrats de maintenance évolutive et corrective. Votre application reste à jour, sécurisée et performante dans le temps. Nous sommes là pour vous accompagner bien après la mise en production."
    }
  ]
};